import { setAuthSessionItem, clearAuthSession } from "utils/authSession";
/* eslint-disable react-hooks/exhaustive-deps */

import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Height from "components/height/height";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { customerLogin } from "utils/authApi";
import { getSesstionDataByUserID } from "utils/generic";
import bgImage from "../../assets/images/download.jpg";

import { loadingAction } from "ReduxReducers/loadingReducer";
import { showResMsg } from "utils/generic";
import {
  InlineFormMessage,
  InlineFieldMessage,
} from "components/InlineFeedback/InlineFeedback";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
function CustomerLogin({ ...props }) {
  const [checkLogin, setCheckLogin] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [phoneNumberErr, setPhoneNumberErr] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    emailAddress: "",
    userPassword: "",
    phoneNumber: "",
    onlyPhoneNumber: "",
  });
  let mandateFlag = false;
  useEffect(() => {
    loadData();
    dispatch(loadingAction(false));
    setAuthSessionItem("LOGIN_ROUTE", "/customerLogin");
  }, []);

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone;
    values.countryCode = "+" + country.dialCode;
  };

  const checkLoginCredentilas = async () => {
    try {
      setFormError("");
      localStorage.phoneNumber = "";
      localStorage.userPassword = "";
      localStorage.loginChecked = false;
      mandateFlag = false;
      if (values.onlyPhoneNumber.toString().trim() !== "") {
        if (
          values.phoneNumber.toString().trim() === "" ||
          values.phoneNumber.toString().trim().length < 12
        ) {
          setPhoneNumberErr(true);
          mandateFlag = true;
        } else {
          setPhoneNumberErr(false);
          values.mobileNumberExist = true;
        }
      } else {
        setPhoneNumberErr(true);
        mandateFlag = true;
      }

      if (values.userPassword.toString().trim() === "") {
        setPasswordErr(true);
        mandateFlag = true;
      } else setPasswordErr(false);

      if (mandateFlag) {
        return;
      }

      setIsSubmitting(true);
      customerLogin(
        values,
        (data) => {
          setIsSubmitting(false);
          if (data.Result_Status) {
            clearAuthSession();
            setAuthSessionItem(
              "LOGIN_DETAILS",
              JSON.stringify(data.Result_Output.data[0])
            );
            setAuthSessionItem(
              "LOGIN_DATETIME",
              JSON.stringify(new Date())
            );
            setAuthSessionItem("TOKEN", data.Result_Output.token);
            if (data.Result_Output.data[0].firstTimeUser === 1) {
              setAuthSessionItem("RESET_PASSWORD", JSON.stringify("false"));
              navigate("/change");
            } else {
              if (values.loginChecked !== false) {
                localStorage.emailAddress = values.emailAddress;
                localStorage.removeItem("userPassword");
                localStorage.loginChecked = values.loginChecked;
              }
              window.location.href = "/orders/customerOrders";
            }
          } else {
            dispatch(loadingAction(false));
            setFormError(data.Result_Message || "Invalid login credentials");
            showResMsg(data.Result_Message, 1000, data.Result_Status);
          }
        },
        dispatch
      );
    } catch (error) {
      setIsSubmitting(false);
      dispatch(loadingAction(false));
      setFormError("An unexpected error occurred. Please try again.");
      console.log("Catch in fetching user=", error);
    }
  };
  async function loadData() {
    if (localStorage.loginChecked && localStorage.phoneNumber !== "") {
      setValues({
        phoneNumber: localStorage.phoneNumber,
        userPassword: "",
        loginChecked: localStorage.loginChecked,
      });
      setCheckLogin(localStorage.loginChecked);
    }

    if (localStorage.viewUserID) {
      let flag = await getSesstionDataByUserID(localStorage.viewUserID);
      setAuthSessionItem("LOGIN_DATETIME", JSON.stringify(new Date()));
      if (flag) {
        navigate("/dashboard");
      } else {
        clearAuthSession();
        props.history.push("/");
      }
      localStorage.removeItem("viewUserID");
    }
  }
  const rememberMe = async (event) => {
    setCheckLogin(!checkLogin);
    if (event.target.checked) {
      values.loginChecked = true;
      localStorage.loginChecked = true;
    } else {
      values.loginChecked = false;
      localStorage.loginChecked = false;
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={3}>
            Invoice & Recover
          </MDTypography>
          <MDTypography variant="h4" fontWeight="medium" color="white">
            Login
          </MDTypography>
          <Grid
            container
            spacing={3}
            justifyContent="center"
            sx={{ mt: 1, mb: 2 }}
          ></Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <InlineFormMessage
              message={formError}
              onClose={() => setFormError("")}
              style={{ marginBottom: "16px" }}
            />
            <Grid item xs={12} md={6} lg={12}>
              <MuiPhoneNumber
                defaultCountry={"au"}
                type="text"
                label="Mobile Number"
                variant="outlined"
                fullWidth
                value={values.phoneNumber}
                onChange={(phone, country) => setPhoneValues(phone, country)}
              />
              <InlineFieldMessage
                error={phoneNumberErr ? "Enter valid 10 digit number" : ""}
              />
            </Grid>

            <Height val={28} />
            <MDBox mb={2}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  value={values.userPassword}
                  onChange={handleChange("userPassword")}
                  inputProps={{
                    maxLength: 30,
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") checkLoginCredentilas();
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        value={values.newPassword}
                        onChange={handleChange("newPassword")}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        ) : (
                          <Visibility
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                <InlineFieldMessage
                  error={passwordErr ? "Password can't be blank" : ""}
                />
              </FormControl>
            </MDBox>
            <Grid container>
              <Grid item lg={6}>
                <MDBox display="flex" alignItems="center" ml={-1}>
                  <Switch checked={checkLogin} onChange={rememberMe} />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    // onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Remember me
                  </MDTypography>
                </MDBox>
              </Grid>

              <Grid item lg={6} textAlign="end">
                <Link to="/customer-reset-pass" className="link">
                  <MDTypography
                    component="a"
                    variant="button"
                    fontWeight="bold"
                    color="info"
                    textGradient
                    style={{ cursor: "pointer" }}
                  >
                    Forgot password?
                  </MDTypography>
                </Link>
              </Grid>
            </Grid>

            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                loading={isSubmitting}
                loadingLabel="Logging in..."
                disabled={isSubmitting}
                onClick={checkLoginCredentilas}
              >
                Login
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/customer/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default CustomerLogin;
